import { useMutation, useQueryClient } from '@tanstack/react-query';
import { roleQueryKeys, Roles } from '#api';
import { makeRoleQueryOptions } from '#api/roles.queries.ts';
import type { Role } from '#dn-types/role.ts';

export function useUpdateRoleCache() {
  const queryClient = useQueryClient();

  return function updateRoleCache(role: Role) {
    void queryClient.invalidateQueries({ queryKey: roleQueryKeys.lists() });
    // Set the returned role into our query cache
    queryClient.setQueryData(makeRoleQueryOptions(role.id).queryKey, { data: role });
  };
}

export function useEditRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: Roles.editRole,
    onSuccess: (data, variables) => {
      void queryClient.invalidateQueries({ queryKey: roleQueryKeys.lists() });
      queryClient.setQueryData(makeRoleQueryOptions(variables.id).queryKey, { data });
    },
  });
}
